import { createSelector } from 'reselect'
import { RootState } from '../accountRoot.reducer'

export const getTheme = createSelector(
  (state: RootState) => state.commonStore.theme,
  (state) => state,
)

export const getUser = createSelector(
  (state: RootState) => state.commonStore.user,
  (state) => state,
)

export const getLanguages = createSelector(
  (state: RootState) => state.commonStore.language,
  (state) => state,
)

export const getMessage = createSelector(
  (state: RootState) => state.commonStore.message,
  (state) => state,
)

export const namedRequestInProgress = createSelector(
  [
    (state: RootState) => state.commonStore.requests,
    (state: RootState, type: string) => type,
  ],
  (state, type) => {
    return state.filter(request => request.type === type && request.inProgress).length > 0
  },
)

export const namedRequestStatus = createSelector(
  [
    (state: RootState) => state.commonStore.requests,
    (state: RootState, type: string) => type,
  ],
  (state, type) => {
    return state.find(request => request.type === type)?.status
  },
)

export const namedRequestData = createSelector(
  [
    (state: RootState) => state.commonStore.requests,
    (state: RootState, type: string) => type,
  ],
  (state, type) => {
    return state.find(request => request.type === type)
  },
)
